import { emitConfirmationModal } from "./organisms/ConfirmationModal/ConfirmationModalRoot";

const SwalAlertComp = (props) => {
    emitConfirmationModal({
        title: props.title,
        message: props.message,
        icon: props.icon,
        timer: props.timer,
    });
};

export default SwalAlertComp;
